<template>
    <az-call-to-action dark
                       :active="true"
                       :outline="false"
                       @click="acessarDocumentos">
        Documentos
    </az-call-to-action>
</template>

<script>
import {mapState} from 'vuex'
import router from "@/router";
export default {
  name: 'CredenciamentoAtualizacaoAcoesDocumentos',
  computed: {
      ...mapState(['licitacao'])
  },
  methods:{
    acessarDocumentos(){
      router.push({name: 'credenciamentoDocumentosVirtualizacao', params: {id: this.licitacao.id}})
    }
  }
}
</script>